module.exports = __webpack_public_path__ + "static/tags-48ced13edbee8c8fdedf8008345b6032.png";